import {BaseService} from './base'
import {RENEWAL_ORDER_STATUS, RENEWAL_TYPE} from "../config";
import {timeFormat} from "../utils";
import {sexFilter} from "../filters";
import {tokenCache} from "../../lib/cache/Token"


class OnlineService extends BaseService {
  constructor() {
    super();
  }
  
  /**
   *
   * @param hosid
   * @param ysid
   * @param bdate
   * @param edate
   * @param date
   * @param orderType
   * @param ksid
   * @param pageNum
   * @param pageSize
   * @returns {Promise<void>}
   */
  async list({hosid, ysid, bdate, edate, date, orderType, ksid, pageNum = 1, pageSize = 1000}) {
    const {code, list, obj} = await this.$http('smarthos.online.outpatient.pack.list', {
      hosid,
      ysid,
      bdate,
      edate,
      date,
      orderType: ysid ? '' : '1',
      ksid,
      pageNum,
      pageSize
    });
    if (code === '0') return {list, obj};
    return {};
  }
  
  /**
   * his订单列表
   * @param hosid
   * @param ysid
   * @param bdate
   * @param edate
   * @param date
   * @param orderType
   * @param pageNum
   * @param pageSize
   * @returns {Promise<void>}
   */
  async list2({hosid, ysid, bdate, edate, date, orderType, pageNum = 1, pageSize = 1000}) {
    const {code, list} = await this.$http('smarthos.yygh.ApiDoctorService.orderByYsid', {
      hosid,
      ysid,
      bdate,
      edate,
      date,
      orderType,
      pageNum,
      pageSize
    });
    if (code === '0') return list;
    return [];
  }
  
  /**
   * 门诊详情
   * @param id
   * @returns {Promise<void>}
   */
  async info(id) {
    const {code, obj} = await this.$http("smarthos.online.outpatient.pack.info", {id});
    return code === '0' ? this.handlerItem(obj) : {};
  }
  
  handlerItem(data) {
    data._sex = sexFilter(data.compatGender);
    return data;
  }
  
  /**
   * 手动短信提醒
   * @param id
   * @returns {Promise<boolean>}
   */
  async sms(id) {
    const {code} = await this.$http('smarthos.online.outpatient.sms.push', {id})
    return code === '0'
  }
  
  /**
   * 进入诊间
   * @param id
   * @returns {Promise<void>}
   */
  async intovideo(id) {
    const {code, obj} = await this.$http('smarthos.online.outpatient.intovideo', {id});
    return code === '0' ? obj : {};
  }
  
  /**
   * 结束问诊
   * @param id
   * @returns {Promise<void>}
   */
  async complete(id) {
    const {code} = await this.$http('smarthos.online.outpatient.complete', {id})
    return code === '0';
  }
  
  /**
   * 检验检查类型列表
   * @param hosId
   * @param inspectionType
   * @returns {Promise<*>}
   */
  async typeList(hosId, inspectionType) {
    let {code, list} = await this.$http('smarthos.referral.inspect.type.list', {
      hosId,
      inspectionType
    });
    if (code === '0') return list;
    return []
  }
  
  /**
   * 检验检查项目列表
   * @param hosId
   * @param inspectTypeId 类型id 非必填
   * @returns {Promise<Array>}
   */
  async inspectList(hosId, inspectTypeId) {
    let {code, list} = await this.$http('smarthos.referral.inspect.list', {
      hosId, inspectTypeId
    });
    if (code === '0') return list;
    return []
  }
  
  /**
   * 开检验检查单
   * @param type INSPECT:检验单 CHECK:检查单
   * @param inspectionTypeName 检验或者检查类型
   * @param inspectionItemName 检验或者检查项目(传一个逗号分隔的字符串)
   * @param commpatIdcard
   * @param commpatName
   * @param commpatPhone
   * @param diagnosis
   * @param sampleType 标本种类，检验单必传(传一个逗号分隔的字符串)
   * @param symptom 主诉及症状
   * @param remark 备注
   * @param hosId
   * @param patId
   * @param module 模块 FOLLOW :聊天开单; CONSULT_INFO 咨询回复开单 ONLINE_OUTPATIENT-网络诊间
   * @returns {Promise<*>}
   */
  async openInspection({type, inspectionTypeName, inspectionItemName, commpatIdcard, commpatName, commpatPhone, diagnosis, sampleType, symptom, remark, hosId, module, patId}) {
    const {code, obj} = await this.$http('smarthos.appiontment.inspection.sheet.insert', {
      type,
      inspectionTypeName,
      inspectionItemName,
      commpatIdcard,
      commpatName,
      commpatPhone,
      diagnosis,
      sampleType,
      symptom,
      remark,
      hosId,
      module,
      patId,
      token: tokenCache.get(),
    });
    if (code === '0') return obj
    return {}
  }
  
}

export const onlineService = new OnlineService();
